<template>
  <div class="q-ml-md">
    <div class="q-mb-lg text-brand-1 text-weight-bold" style="font-size: 16px">
      Gestão de Biometria do Usuário
    </div>
    <ComponenteBiometria
      :idUsuario="userId"
      :tipoMetodo="'cadastro'"
      :atualizarDedosCadastrados="atualizarDedosCadastrados"
      @atualizarBiometrias="atualizarBiometriaFuncionarios"
    />
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import ComponenteBiometria from "../../../components/biometriaNovo/ComponenteBiometria.vue";

const store = useStore();
const quasar = useQuasar();

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const atualizarDedosCadastrados = ref(0);

const atualizarBiometriaFuncionarios = async () => {
  try {
    await store.dispatch("usuarioNovo/atualizarBiometriaFuncionarios");
    quasar.notify({
      message: "A atualização está sendo processada.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    atualizarDedosCadastrados.value++;
  } catch (error) {
    console.log(error);
  }
};
</script>
